var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{staticClass:"image",attrs:{"src":_vm.src,"alt":"test card"}})
}
var staticRenderFns = []

export { render, staticRenderFns }